/**
 * Match backend/src/utils/contentGenerationSubtasks.js for UI parity (subtask counts vs generation).
 */

const IAC_CODE_PATTERN = /IAC\d{4}/i;

export function isAssessmentSubtask(node) {
  if (!node || typeof node !== 'object') return false;
  if (node.node_type === 'assessment_criterion') return true;
  const code = typeof node.code === 'string' ? node.code : '';
  if (code && IAC_CODE_PATTERN.test(code)) return true;
  return false;
}

export function filterChildrenForContentGeneration(children) {
  if (!Array.isArray(children)) return [];
  return children.filter((c) => !isAssessmentSubtask(c));
}
